/*!

 =========================================================
 * Vue Light Bootstrap Dashboard - v2.1.0 (Bootstrap 4)
 =========================================================

 * Product Page: http://www.creative-tim.com/product/light-bootstrap-dashboard
 * Copyright 2023 Creative Tim (http://www.creative-tim.com)
 * Licensed under MIT (https://github.com/creativetimofficial/light-bootstrap-dashboard/blob/master/LICENSE.md)

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

 */
import Vue from "vue";
import VueRouter from "vue-router";
import App from "./App.vue";

// LightBootstrap plugin

import LightBootstrap from "./light-bootstrap-main";

import {BootstrapVue, IconsPlugin, ModalPlugin} from 'bootstrap-vue';

// Import Bootstrap an BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'vue-form-wizard/dist/vue-form-wizard.min.css';

// Import global UX enhancements
import './assets/css/global-enhancements.css';
import './assets/css/acceldata-flagsmith.css';
import {FormDatepickerPlugin, FormTimepickerPlugin, OverlayPlugin} from "bootstrap-vue";

// router setup
import routes from "./routes/routes";
import "./registerServiceWorker";
import NotificationPlugin from "@/components/NotificationPlugin";

import NotificationsPlugin from "@/components/NotificationPlugin";
import { ToastPlugin } from 'bootstrap-vue'
import { BButton } from 'bootstrap-vue'
// Import vue-form-wizard plugin
import VueFormWizard from 'vue-form-wizard';

// plugin setup
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(VueRouter);
Vue.use(FormDatepickerPlugin);
Vue.use(FormTimepickerPlugin);
Vue.use(LightBootstrap);
Vue.use(VueFormWizard);
Vue.component('b-button', BButton);
Vue.use(NotificationsPlugin, {
  overlap: false,
  verticalAlign: 'top',
  horizontalAlign: 'right',
  timeout: 5000,
  closeOnClick: true,
  showClose: true
});
Vue.use(ToastPlugin)
Vue.use(OverlayPlugin)


// configure router
const router = new VueRouter({
  mode: "history",
  routes, // short for routes: routes
  linkActiveClass: "nav-item active",
  scrollBehavior: (to) => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  },
});



export default router;

/* eslint-disable no-new */
new Vue({
  el: "#app",
  render: (h) => h(App),
  router,
});
